import { signInWithEmailAndPassword } from "firebase/auth";
import { BaseAxios } from "./base-axios";
import { auth } from "@/firebase";
import { LOCALSTORAGE_KEY } from "@/utils/constants";
import { User } from "@/utils/interface/user";
import { InviteUserSchemaType } from "@/schemas/invite-user-schema";
import { UserInvitationStatus } from "@/utils/enum/user-role.enum";

class AuthAPI extends BaseAxios {
  constructor() {
    super(`${import.meta.env.VITE_BACKEND_URL}/auth`);
  }

  async login(email: string, password: string): Promise<User> {
    try {
      // First try to sign in with email/password
      let userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const token = await userCredential.user.getIdToken();

      const response = await this.post<User>("/login", {
        token,
      });

      const newToken = (await auth.currentUser?.getIdToken(true)) || "";

      localStorage.setItem(LOCALSTORAGE_KEY.AUTH_TOKEN, newToken);
      return response;
    } catch (error) {
      console.error("Login error:", error);
      throw new Error("Login failed. Please check your credentials.");
    }
  }

  async sendInviteLink(
    payload: InviteUserSchemaType
  ): Promise<{ email: string }> {
    const resp = await this.post<{ email: string }>("create-invite", payload, {
      headers: {
        Authorization: this.authtoken,
      },
    });

    const token = (await auth.currentUser?.getIdToken(true)) || "";

    localStorage.setItem(LOCALSTORAGE_KEY.AUTH_TOKEN, token);
    return resp;
  }

  async verifyInvite(token: string) {
    return this.get<{ status: UserInvitationStatus; email: string }>(
      "verify-invite",
      {
        params: {
          token,
        },
      }
    );
  }

  async setPassword(payload: { token: string; password: string }) {
    return this.post<User>("set-password", payload);
  }
}

export const authAPI = new AuthAPI();
